var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E9EFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 42.75C26.0629 42.75 21.25 37.9371 21.25 32C21.25 26.0629 26.0629 21.25 32 21.25C37.9371 21.25 42.75 26.0629 42.75 32C42.75 37.9371 37.9371 42.75 32 42.75ZM32.5607 31.4394C32.2707 31.1494 31.9289 31.0605 31.6819 31.0273C31.4772 30.9997 31.2393 30.9999 31.0394 31L31 31C30.4477 31 30 31.4477 30 32C30 32.5523 30.4477 33 31 33V37C31 37.5523 31.4477 38 32 38C32.5523 38 33 37.5523 33 37L33 32.9606C33.0001 32.7608 33.0003 32.5228 32.9728 32.3182C32.9396 32.0711 32.8507 31.7294 32.5607 31.4394ZM30.9999 28C30.9999 27.4477 31.4456 27 31.9954 27H32.0044C32.5542 27 32.9999 27.4477 32.9999 28C32.9999 28.5523 32.5542 29 32.0044 29H31.9954C31.4456 29 30.9999 28.5523 30.9999 28Z",
    fill: "#5335E9",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.26672bf835e9f248ae104dcb3c86b5d2.svg";
export { ForwardRef as ReactComponent };